import { getBase64, lt, showSuccessAlert } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { AccountFile } from '@mews-commander/data-access';
import { getFirstFile } from '@mews-commander/utils';
import { addFile, deleteFile, updateFile } from '@mews-commander/legacy-entities/src/actions/files';
import { getOwnerSortedFilesIds } from '@mews-commander/legacy-entities/src/ducks/files';
import { DEFAULT_MIME_TYPE } from '../../constants';
import { createAddAction, createDeleteAction, createEditAction } from '../entityManagement';
import { getSelectedEntityId } from '../entityManagement/selectors';
import { changePaginationIds } from '../pagination/actions';
import { getContractFileAddDataValues, getContractFileUpdateDataValues } from './selectors';
import { ContractFileValues, ContractInfoValues } from './types';

const contractAdder = createAddAction(addFile);
export const addContractFileAction =
    (values: ContractFileValues, ownerId: string, scope: string): CommanderThunkAction<Promise<void>> =>
    async (dispatch, getState) => {
        const file = getFirstFile(values) as File;
        const base64 = await getBase64(file);
        const { name, type } = file;
        const data = getContractFileAddDataValues(getState(), { values });
        const files = [
            {
                name,
                type: type || DEFAULT_MIME_TYPE,
                content: base64,
                accountId: ownerId,
                data,
            },
        ];

        await dispatch(contractAdder({ files, ownerId }, scope));
        dispatch(fileListChanged(ownerId, scope));
        showSuccessAlert({ description: lt('SaveSuccessMessage') });
    };

const contractDeletor = createDeleteAction(deleteFile);
export const deleteContractFileAction =
    (ownerId: string, scope: string): CommanderThunkAction<Promise<void>> =>
    (dispatch) =>
        dispatch(contractDeletor({ ownerId }, scope)).then((deletedFile: AccountFile) => {
            const entity = deletedFile?.name;
            dispatch(fileListChanged(ownerId, scope));
            showSuccessAlert({
                description: lt('DeleteSuccessMessage', entity ? { entity } : {}),
            });
        });

const contractUpdater = createEditAction(updateFile);
export const updateContractAction =
    (values: ContractInfoValues, ownerId: string, scope: string): CommanderThunkAction<Promise<void>> =>
    async (dispatch, getState) => {
        const state = getState();
        const id = getSelectedEntityId(state, { scope });
        const data = getContractFileUpdateDataValues(state, { values, id });
        const accountFileUpdates = [
            {
                id,
                data,
            },
        ];
        await dispatch(contractUpdater({ accountFileUpdates }, scope));
        dispatch(fileListChanged(ownerId, scope));
        showSuccessAlert({ description: lt('SaveSuccessMessage') });
    };

const fileListChanged =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getOwnerSortedFilesIds(getState(), { ownerId });
        dispatch(changePaginationIds(ids, scope));
    };
